import { render, staticRenderFns } from "./storedcarditems.vue?vue&type=template&id=22f20224&scoped=true&"
import script from "./storedcarditems.vue?vue&type=script&lang=js&"
export * from "./storedcarditems.vue?vue&type=script&lang=js&"
import style0 from "./storedcarditems.vue?vue&type=style&index=0&id=22f20224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f20224",
  null
  
)

export default component.exports